import React from 'react'
import Head from 'next/head'
import {toggle} from 'opticks'

import {
  getFontFaces as getFontFacesExperimental,
  getTypographyCssVariables
} from '../../experimental/FontsLoader'
import {fontVariables, getFontFaces} from '../FontsLoader/FontsLoader'

interface PropsType {
  languageCode: string
  // We need a prop for Search, as this one will be evaluated on the server
  isBSideNonLatinFontsExperiment?: boolean
}

const FontsLoaderNext = ({
  languageCode,
  isBSideNonLatinFontsExperiment = false
}: PropsType) => {
  const isBSide =
    isBSideNonLatinFontsExperiment ||
    toggle('319d377e-non-latin-fonts', false, true)
  if (isBSide) {
    return (
      <Head>
        <style
          id="vio-fonts-loader"
          dangerouslySetInnerHTML={{
            __html: `${getFontFacesExperimental(languageCode)}\n${getTypographyCssVariables(languageCode)}`
          }}
        />
      </Head>
    )
  }

  return (
    <Head>
      <style
        id="vio-fonts-loader"
        dangerouslySetInnerHTML={{
          __html: `${getFontFaces(languageCode)}\n${fontVariables}`
        }}
      />
    </Head>
  )
}

export default FontsLoaderNext
